import React from 'react';

export default function PageTitle({ titleText }) {
  return (
    <div className="mt-4">
      <h5 className="text-center">{titleText}</h5>
    </div>
  );
}
